import { z } from 'zod'

export const belgeInfoSchema = z.object({
  ad: z.string().trim().min(2, 'required'),
  kategori: z.string().min(1, 'required'),
  aciklama: z.string().trim().max(1000),
  zorunlu: z.boolean(),
  departmanIds: z.array(z.string()),
  /** Sistemdeki pozisyon kayıtlarının id'leri. */
  pozisyonlar: z.array(z.guid()),
  /** Kontrol sorumlusu personel kaydının id'si (firma sahipleri de personel olarak seçilebilir). */
  kontrolSorumlusu: z.guid('required'),
})

export type BelgeInfoValues = z.infer<typeof belgeInfoSchema>

export const emptyBelgeInfo = (): BelgeInfoValues => ({
  ad: '',
  kategori: 'onboarding',
  aciklama: '',
  zorunlu: true,
  departmanIds: [],
  pozisyonlar: [],
  kontrolSorumlusu: '',
})
